import { splitIntoChunks } from "../utils/textUtils";

export const useTTS = () => {
  let isSpeaking = false;

  const speak = async ({ text, setIsSpeaking = null, setIsError = null }) => {
    if (!text) return;

    const chunks = splitIntoChunks(text);
    const voices = speechSynthesis.getVoices();
    const voice =
      voices.find((voice) => voice.name === "Google UK English Male") ||
      voices.find((voice) => voice.name === "Samantha") ||
      voices.find(
        (voice) => voice.name.includes("Guy") && voice.name.includes("Online")
      ) ||
      voices[0];

    speechSynthesis.cancel();
    isSpeaking = true;
    if (setIsSpeaking) setIsSpeaking(true);

    try {
      for (let index = 0; index < chunks.length; index++) {
        if (!isSpeaking) break; // 중단 요청이 있으면 루프 탈출

        const chunk = chunks[index];
        await new Promise((resolve, reject) => {
          const utterance = new SpeechSynthesisUtterance(chunk);
          utterance.voice = voice || null;
          utterance.lang = "en-US";
          if (voice.name === "Samantha") utterance.rate = 0.6;
          else utterance.rate = 0.8;
          utterance.pitch = 1;

          utterance.onend = () => {
            if (isSpeaking && index === chunks.length - 1 && setIsSpeaking) {
              setIsSpeaking(false);
            }
            resolve();
          };

          utterance.onerror = (error) => {
            if (setIsError) setIsError(error);
            reject(error);
          };

          speechSynthesis.speak(utterance);
        });
      }
    } catch (error) {
      console.error("Speech synthesis error:", error);
    } finally {
      isSpeaking = false;
    }
  };

  const stopSpeaking = () => {
    isSpeaking = false; // 중단 요청
    speechSynthesis.cancel();
  };

  return { speak, stopSpeaking };
};
